import { render } from "./payment-history.vue?vue&type=template&id=4fa89d42&scoped=true"
import script from "./payment-history.vue?vue&type=script&lang=js"
export * from "./payment-history.vue?vue&type=script&lang=js"

import "./payment-history.vue?vue&type=style&index=0&id=4fa89d42&scoped=true&lang=css"

import exportComponent from "C:\\inetpub\\wwwroot\\frontend\\employer-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fa89d42"]])

export default __exports__